import {maskAccountNum} from '@principal/text-formatters';

export const Transfers = class {
  // eslint-disable-next-line max-statements, max-lines-per-function
  constructor() {
    this.plaidCompleteStatus = true;
    this.frequency = null;
    this.summaryTransfer = [];
    this.plaidData = [];
    this.plaidMetadata = null;
    this.accessToken = null;
    this.linkNewBankAccountData = [];
    this.isRetirementAccount = false;
    this.isIraConstraints = false;
    this.iraConstraints = null;
    this.transferFrequency = null;
    this.fedTaxWithholdingValue = null;
    this.stateTaxWithholdingValue = null;
    this.type = null;
    this.distributionReason = null;
    this.destinationId = null;
    this.accountId = null;
    this.sourceId = null;
    this.bankAccountId = null;
    this.sourceBankAccounts = [];
    this.destinationBankAccounts = [];
    this.requestedTransfers = [];
    this.requestedBankLinks = [];
    this.clientContributionTypes = [];
    this._accounts = {
      bank: [],
      brokerage: [],
    };
    this.transferDetail = {
      custodianName: null,
      custodianCode: null,
    };
    this.depositVerificationResponse = {
      attemptId: null,
      remainingAttempts: 3,
      isApproved: true,
    };
    this.showInsufficientFundsModal = false;
    this.depositAttemptIds = new Map();
    this.linkedBankCustodianAccounts = {bankAccounts: []};

    // transfer object
    this.contributionYear = null;
    this.amount = 0;
    this.frequency = null;
    this.date = null;
    this.to = null;
    this.from = null;
    this.isIra = false;
    this.isEdit = false;
    // roll over
    this.rollover = null;
    this.advisorInitiated = false;
    this.distributionReasonText = null;
    this.contributionTypeText = null;
    this.microDeposit = false;
    this.failedToFetchTransfer = false;
    this.previousYearTaxDate = null;
    this.delayedTransfers = [];
    this.isExempted = false;
    this.stateTaxWithholdingData = null;
    this.optOutFormChecked = false;
  }
};

export const formatBank = (item) => {
  if (!item) {
    return true;
  }

  const maskedNumber = item.bankAccountNumberLastFour
    ? `(${maskAccountNum({accountNum: item.bankAccountNumberLastFour, prefixLength: 12, maskCharacter: '*'})})`
    : '';
  const formattedName = item.bankName ? `${item.bankName} ${maskedNumber}` : `${item.bankAccountType} ${maskedNumber}`;

  return {
    id: item.id,
    name: item.bankName || formattedName,
    type: item.bankAccountType,
    maskedAccountNumber: maskedNumber,
    formattedName,
    linked: item.linked,
    disabled: item.disabled,
  };
};

export const formatBrokerage = (item) => {
  const maskedNumber = maskAccountNum({accountNum: item.custodianAccountNumber, maskCharacter: '*'});

  return {
    id: item.accountId,
    name: item.accountName,
    type: item.accountType,
    typeCode: item.accountTypeCode,
    accountTypeId: item.accountTypeId,
    taxId: item.taxId,
    accountNumber: item.custodianAccountNumber,
    maskedAccountNumber: maskedNumber,
    formattedName: `${item.accountName} (${maskedNumber})`,
    custodianId: item.custodianId,
    custodianName: item.custodian,
    isIra: item.isIra,
    isAccountInLiquidationProcess: item.isAccountInLiquidationProcess,
    aum: item.aum,
  };
};
